import * as React from 'react';
import classNames from 'classnames';
import {PropsWithChildren} from "react";

export interface ILayoutSplitColumnProps extends PropsWithChildren {
    /** className to append */
    className?: string;
}

interface IState {
}

/**
 * Column to be used inside LayoutSplit
 */
class LayoutSplitColumn extends React.Component<ILayoutSplitColumnProps, IState> {
    static displayName: string = 'LayoutSplitColumn';

    render () {
        return this.props.children ? (
            <div className={classNames('layout-split-column', this.props.className)}>
                {this.props.children}
            </div>
        ) : <React.Fragment/>;
    }
}

export default LayoutSplitColumn;
